import { useDebtor } from 'app/Private/Clients/Detail/client-atom';
import { useLoadUnhandledClient } from 'modules/AtRisk/api/use-load-unhandled-client';
import { useEffect } from 'react';
import { prop } from 'remeda';
import { UnhandledInvoicesNextAction } from './UnhandledInvoicesNextAction';
import { UnhandledInvoicesLayout } from './UnhandledinvoicesLayout';
import { useBuildActionButtons } from './use-build-action-buttons';
import { useInvoiceSelection } from './use-invoice-selection';

export const UnhandledInvoices = () => {
  const debtor = useDebtor();

  const {
    isUnhandledClientInitialLoading,
    unhandledClient: { recommendedActions, unhandledInvoices },
  } = useLoadUnhandledClient({ debtorId: String(debtor.id) });
  const { initializeSelectedIds } = useInvoiceSelection();
  const actionButtonGroups = useBuildActionButtons(recommendedActions, unhandledInvoices);

  useEffect(
    () => initializeSelectedIds(unhandledInvoices.map(prop('id'))),
    [unhandledInvoices, initializeSelectedIds],
  );

  if (!isUnhandledClientInitialLoading && unhandledInvoices.length === 0)
    return <UnhandledInvoicesNextAction />;

  return (
    <UnhandledInvoicesLayout actionButtonGroups={actionButtonGroups} invoices={unhandledInvoices} />
  );
};
